export default __webpack_public_path__ + "static/media/setion01_bg.fe33271c.jpg";